<template>
  <section class="guia-tramites-restricciones" aria-labelledby="guia-tramites-restricciones-title">
    <h2 id="guia-tramites-restricciones-title" class="guia-tramites-restricciones__title">
      Restricciones y consideraciones importantes
    </h2>

    <div class="guia-tramites-restricciones__items">
      <DsWarningItem
        v-for="aviso in avisos"
        :key="aviso.label"
        :label="aviso.label"
        :text="aviso.text"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import DsWarningItem from '../atoms/DsWarningItem.vue'

const avisos = [
  {
    label: 'Incremento:',
    text: 'Aplica exclusivamente para la etapa de integrante y está sujeto a precalificación de ingresos y un límite máximo de $500,000.00.'
  },
  {
    label: 'Facturación:',
    text: 'Solo se pueden emitir facturas dentro del mes y posterior a la solicitud de alta. Existen regímenes no deducibles (como 605 Sueldos y Salarios, 607 Enajenación o Adquisición de Bienes, 608 Demás ingresos, 610 Residentes en el Extranjero, 611 Dividendos, 614 Intereses, y 615 Premios). Consulta previamente si te encuentras en alguno de ellos.'
  }
]
</script>

<style scoped>
.guia-tramites-restricciones {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.guia-tramites-restricciones__title {
  margin: 0;
  font-family: var(--ds-font-family-bebas);
  font-size: var(--ds-bebas4-size);
  font-weight: 700;
  color: var(--ds-purple-900);
}

.guia-tramites-restricciones__items {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
